import STATIC_ROUTE_METADATA from "./staticRoutes.generated.json";

export const ROUTE_SEO = {
  "/": {
    title: "FPEP Bar | Fakultet za poslovnu ekonomiju i pravo",
    description:
      "Fakultet za poslovnu ekonomiju i pravo Bar — studijski programi iz ekonomije, menadžmenta i prava, upis, Erasmus, međunarodni projekti i studentski život.",
    pageType: "WebSite",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
    ],
  },
  "/aktuelnosti/ljetnja-skola-bar-2026": {
    title: "Ljetnja škola Bar 2026 | FPEP Bar",
    description:
      "Summer School Bar 2026 na FPEP Bar: međunarodni program sa studentima Hochschule Burgenland, institucionalnim posjetama, nastavom, kulturom i obilaskom Crne Gore.",
    pageType: "WebPage",
    breadcrumbs: [
      { name: "Početna", path: "/" },
      { name: "Aktuelnosti", path: "/novosti" },
      {
        name: "Ljetnja škola Bar 2026",
        path: "/aktuelnosti/ljetnja-skola-bar-2026",
      },
    ],
  },
  "/specijalisticke-studije": {
    title: "Specijalističke studije | FPEP Bar",
    description:
      "Važno obavještenje za kandidate: specijalističke studije na FPEP Bar povezane su sa aktuelnim master modelom studiranja i nastavkom kroz master programe.",
    pageType: "WebPage",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Specijalističke studije",
        path: "/specijalisticke-studije",
      },
    ],
  },
  "/akademski-integritet": {
    title: "Akademski integritet | FPEP Bar",
    description:
      "Akademski integritet na FPEP Bar: pravila, dokumenta, etički okvir i institucionalni pristup odgovornom akademskom radu.",
    pageType: "WebPage",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Pravni akti",
        path: "/o-nama",
      },
      {
        name: "Akademski integritet",
        path: "/akademski-integritet",
      },
    ],
  },
  "/akademsko-pisanje-poas": {
    title: "Akademsko pisanje | Pravo | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Akademsko pisanje" na programu Pravo (Osnovne studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Pravo",
        path: "/pravo-osnovne",
      },
      {
        name: "Akademsko pisanje",
        path: "/akademsko-pisanje-poas",
      },
    ],
    courseTitle: "Akademsko pisanje",
    programName: "Pravo",
    studyLevel: "Osnovne studije",
  },
  "/akreditacija-fpep": {
    title: "Akreditacija i licence | FPEP Bar",
    description:
      "Akreditacije, licence i zvanična dokumenta Fakulteta za poslovnu ekonomiju i pravo Bar — pregled institucionalne usklađenosti i statusa studijskih programa.",
    pageType: "WebPage",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Upis",
        path: "/upis",
      },
      {
        name: "Akreditacija i licence",
        path: "/akreditacija-fpep",
      },
    ],
  },
  "/alumni-klub": {
    title: "Alumni klub | FPEP Bar",
    description:
      "Alumni klub FPEP Bar — mreža bivših studenata, profesionalne veze, saradnja sa fakultetom i dugoročno jačanje akademske zajednice.",
    pageType: "WebPage",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studenti",
        path: "/studenti",
      },
      {
        name: "Alumni klub",
        path: "/alumni-klub",
      },
    ],
  },
  "/analiza-poslovanja-m": {
    title: "Analiza poslovanja | Menadžment | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Analiza poslovanja" na programu Menadžment (Osnovne studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Menadžment",
        path: "/menadzment",
      },
      {
        name: "Analiza poslovanja",
        path: "/analiza-poslovanja-m",
      },
    ],
    courseTitle: "Analiza poslovanja",
    programName: "Menadžment",
    studyLevel: "Osnovne studije",
  },
  "/analiza-poslovanja-rfb": {
    title:
      "Analiza poslovanja | Računovodstvo, finansije i bankarstvo | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Analiza poslovanja" na programu Računovodstvo, finansije i bankarstvo (Osnovne studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Računovodstvo, finansije i bankarstvo",
        path: "/racunovodstvo-finansije-i-bankarstvo",
      },
      {
        name: "Analiza poslovanja",
        path: "/analiza-poslovanja-rfb",
      },
    ],
    courseTitle: "Analiza poslovanja",
    programName: "Računovodstvo, finansije i bankarstvo",
    studyLevel: "Osnovne studije",
  },
  "/arbitrazno-pravo-pm": {
    title: "Arbitražno pravo | Pravo | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Arbitražno pravo" na programu Pravo (Master studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Pravo",
        path: "/pravo-master",
      },
      {
        name: "Arbitražno pravo",
        path: "/arbitrazno-pravo-pm",
      },
    ],
    courseTitle: "Arbitražno pravo",
    programName: "Pravo",
    studyLevel: "Master studije",
  },
  "/bankarstvo-rfb": {
    title: "Bankarstvo | Računovodstvo, finansije i bankarstvo | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Bankarstvo" na programu Računovodstvo, finansije i bankarstvo (Osnovne studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Računovodstvo, finansije i bankarstvo",
        path: "/racunovodstvo-finansije-i-bankarstvo",
      },
      {
        name: "Bankarstvo",
        path: "/bankarstvo-rfb",
      },
    ],
    courseTitle: "Bankarstvo",
    programName: "Računovodstvo, finansije i bankarstvo",
    studyLevel: "Osnovne studije",
  },
  "/biznis-analiza-pem": {
    title: "Biznis analiza | Poslovna ekonomija | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Biznis analiza" na programu Poslovna ekonomija (Master studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Poslovna ekonomija",
        path: "/poslovna-ekonomija",
      },
      {
        name: "Biznis analiza",
        path: "/biznis-analiza-pem",
      },
    ],
    courseTitle: "Biznis analiza",
    programName: "Poslovna ekonomija",
    studyLevel: "Master studije",
  },
  "/biznis-etika-kultura-m": {
    title: "Biznis etika i kultura | Menadžment | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Biznis etika i kultura" na programu Menadžment (Osnovne studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Menadžment",
        path: "/menadzment",
      },
      {
        name: "Biznis etika i kultura",
        path: "/biznis-etika-kultura-m",
      },
    ],
    courseTitle: "Biznis etika i kultura",
    programName: "Menadžment",
    studyLevel: "Osnovne studije",
  },
  "/biznis-i-preduzetnistvo-pem": {
    title: "Biznis i preduzetništvo | Poslovna ekonomija | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Biznis i preduzetništvo" na programu Poslovna ekonomija (Master studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Poslovna ekonomija",
        path: "/poslovna-ekonomija",
      },
      {
        name: "Biznis i preduzetništvo",
        path: "/biznis-i-preduzetnistvo-pem",
      },
    ],
    courseTitle: "Biznis i preduzetništvo",
    programName: "Poslovna ekonomija",
    studyLevel: "Master studije",
  },
  "/carinsko-poslovanje-rfb": {
    title:
      "Carinsko poslovanje | Računovodstvo, finansije i bankarstvo | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Carinsko poslovanje" na programu Računovodstvo, finansije i bankarstvo (Osnovne studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Računovodstvo, finansije i bankarstvo",
        path: "/racunovodstvo-finansije-i-bankarstvo",
      },
      {
        name: "Carinsko poslovanje",
        path: "/carinsko-poslovanje-rfb",
      },
    ],
    courseTitle: "Carinsko poslovanje",
    programName: "Računovodstvo, finansije i bankarstvo",
    studyLevel: "Osnovne studije",
  },
  "/cijene-studija": {
    title: "Cijene studija | FPEP Bar",
    description:
      "Pregled cijena studija i školarine na FPEP Bar za osnovne, specijalističke i master studije, uz važne finansijske informacije za studente.",
    pageType: "WebPage",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Upis",
        path: "/upis",
      },
      {
        name: "Cijene studija",
        path: "/cijene-studija",
      },
    ],
  },
  "/diplomatsko-i-konzularno-pravo-pm": {
    title: "Diplomatsko i konzularno pravo | Pravo | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Diplomatsko i konzularno pravo" na programu Pravo (Master studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Pravo",
        path: "/pravo-master",
      },
      {
        name: "Diplomatsko i konzularno pravo",
        path: "/diplomatsko-i-konzularno-pravo-pm",
      },
    ],
    courseTitle: "Diplomatsko i konzularno pravo",
    programName: "Pravo",
    studyLevel: "Master studije",
  },
  "/dom-studenata": {
    title: "Dom studenata | FPEP Bar",
    description:
      "Informacije o domu studenata i studentskom smještaju za studente Fakulteta za poslovnu ekonomiju i pravo Bar.",
    pageType: "WebPage",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studenti",
        path: "/studenti",
      },
      {
        name: "Dom studenata",
        path: "/dom-studenata",
      },
    ],
  },
  "/dozvole-za-rad": {
    title: "Dozvole za rad | FPEP Bar",
    description:
      "Zvanične dozvole za rad, licenciranje i institucionalna dokumenta Fakulteta za poslovnu ekonomiju i pravo Bar.",
    pageType: "WebPage",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Pravni akti",
        path: "/o-nama",
      },
      {
        name: "Dozvole za rad",
        path: "/dozvole-za-rad",
      },
    ],
  },
  "/ekonomija-javnog-sektora": {
    title: "Ekonomija javnog sektora – master studije | FPEP Bar",
    description:
      "Program postdiplomskih akademskih studija 'Ekonomija javnog sektora' na Fakultetu za poslovnu ekonomiju i pravo Bar nudi studentima napredno obrazovanje u…",
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Ekonomija javnog sektora",
        path: "/ekonomija-javnog-sektora",
      },
    ],
  },
  "/ekonomija-javnog-sektora-ejs": {
    title: "Ekonomija javnog sektora | Ekonomija javnog sektora | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Ekonomija javnog sektora" na programu Ekonomija javnog sektora (Master studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Ekonomija javnog sektora",
        path: "/ekonomija-javnog-sektora",
      },
      {
        name: "Ekonomija javnog sektora",
        path: "/ekonomija-javnog-sektora-ejs",
      },
    ],
    courseTitle: "Ekonomija javnog sektora",
    programName: "Ekonomija javnog sektora",
    studyLevel: "Master studije",
  },
  "/ekonomika-preduzeca-rfb": {
    title:
      "Ekonomika preduzeća | Računovodstvo, finansije i bankarstvo | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Ekonomika preduzeća" na programu Računovodstvo, finansije i bankarstvo (Osnovne studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Računovodstvo, finansije i bankarstvo",
        path: "/racunovodstvo-finansije-i-bankarstvo",
      },
      {
        name: "Ekonomika preduzeća",
        path: "/ekonomika-preduzeca-rfb",
      },
    ],
    courseTitle: "Ekonomika preduzeća",
    programName: "Računovodstvo, finansije i bankarstvo",
    studyLevel: "Osnovne studije",
  },
  "/ekonomika-sportskih-organizacija-rfb": {
    title:
      "Ekonomika sportskih organizacija | Računovodstvo, finansije i bankarstvo | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Ekonomika sportskih organizacija" na programu Računovodstvo, finansije i bankarstvo (Osnovne studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Računovodstvo, finansije i bankarstvo",
        path: "/racunovodstvo-finansije-i-bankarstvo",
      },
      {
        name: "Ekonomika sportskih organizacija",
        path: "/ekonomika-sportskih-organizacija-rfb",
      },
    ],
    courseTitle: "Ekonomika sportskih organizacija",
    programName: "Računovodstvo, finansije i bankarstvo",
    studyLevel: "Osnovne studije",
  },
  "/elektronski-biznis-pem": {
    title: "Elektronski biznis | Poslovna ekonomija | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Elektronski biznis" na programu Poslovna ekonomija (Master studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Poslovna ekonomija",
        path: "/poslovna-ekonomija",
      },
      {
        name: "Elektronski biznis",
        path: "/elektronski-biznis-pem",
      },
    ],
    courseTitle: "Elektronski biznis",
    programName: "Poslovna ekonomija",
    studyLevel: "Master studije",
  },
  "/elektronsko-poslovanje-m": {
    title: "Elektronsko poslovanje | Menadžment | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Elektronsko poslovanje" na programu Menadžment (Osnovne studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Menadžment",
        path: "/menadzment",
      },
      {
        name: "Elektronsko poslovanje",
        path: "/elektronsko-poslovanje-m",
      },
    ],
    courseTitle: "Elektronsko poslovanje",
    programName: "Menadžment",
    studyLevel: "Osnovne studije",
  },
  "/elektronsko-poslovanje-rfb": {
    title:
      "Elektronsko poslovanje | Računovodstvo, finansije i bankarstvo | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Elektronsko poslovanje" na programu Računovodstvo, finansije i bankarstvo (Osnovne studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Računovodstvo, finansije i bankarstvo",
        path: "/racunovodstvo-finansije-i-bankarstvo",
      },
      {
        name: "Elektronsko poslovanje",
        path: "/elektronsko-poslovanje-rfb",
      },
    ],
    courseTitle: "Elektronsko poslovanje",
    programName: "Računovodstvo, finansije i bankarstvo",
    studyLevel: "Osnovne studije",
  },
  "/engleski-jezik-I-m": {
    title: "Engleski jezik I | Menadžment | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Engleski jezik I" na programu Menadžment (Osnovne studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Menadžment",
        path: "/menadzment",
      },
      {
        name: "Engleski jezik I",
        path: "/engleski-jezik-I-m",
      },
    ],
    courseTitle: "Engleski jezik I",
    programName: "Menadžment",
    studyLevel: "Osnovne studije",
  },
  "/engleski-jezik-I-poas": {
    title: "Engleski jezik I | Pravo | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Engleski jezik I" na programu Pravo (Osnovne studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Pravo",
        path: "/pravo-osnovne",
      },
      {
        name: "Engleski jezik I",
        path: "/engleski-jezik-I-poas",
      },
    ],
    courseTitle: "Engleski jezik I",
    programName: "Pravo",
    studyLevel: "Osnovne studije",
  },
  "/engleski-jezik-I-rfb": {
    title:
      "Engleski jezik I | Računovodstvo, finansije i bankarstvo | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Engleski jezik I" na programu Računovodstvo, finansije i bankarstvo (Osnovne studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Računovodstvo, finansije i bankarstvo",
        path: "/racunovodstvo-finansije-i-bankarstvo",
      },
      {
        name: "Engleski jezik I",
        path: "/engleski-jezik-I-rfb",
      },
    ],
    courseTitle: "Engleski jezik I",
    programName: "Računovodstvo, finansije i bankarstvo",
    studyLevel: "Osnovne studije",
  },
  "/engleski-jezik-II-m": {
    title: "Engleski jezik II | Menadžment | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Engleski jezik II" na programu Menadžment (Osnovne studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Menadžment",
        path: "/menadzment",
      },
      {
        name: "Engleski jezik II",
        path: "/engleski-jezik-II-m",
      },
    ],
    courseTitle: "Engleski jezik II",
    programName: "Menadžment",
    studyLevel: "Osnovne studije",
  },
  "/engleski-jezik-II-poas": {
    title: "Engleski jezik II | Pravo | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Engleski jezik II" na programu Pravo (Osnovne studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Pravo",
        path: "/pravo-osnovne",
      },
      {
        name: "Engleski jezik II",
        path: "/engleski-jezik-II-poas",
      },
    ],
    courseTitle: "Engleski jezik II",
    programName: "Pravo",
    studyLevel: "Osnovne studije",
  },
  "/engleski-jezik-II-rfb": {
    title:
      "Engleski jezik II | Računovodstvo, finansije i bankarstvo | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Engleski jezik II" na programu Računovodstvo, finansije i bankarstvo (Osnovne studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Računovodstvo, finansije i bankarstvo",
        path: "/racunovodstvo-finansije-i-bankarstvo",
      },
      {
        name: "Engleski jezik II",
        path: "/engleski-jezik-II-rfb",
      },
    ],
    courseTitle: "Engleski jezik II",
    programName: "Računovodstvo, finansije i bankarstvo",
    studyLevel: "Osnovne studije",
  },
  "/erasmus": {
    title: "Erasmus+ | FPEP Bar",
    description:
      "Erasmus+ na FPEP Bar: studentske i osoblje mobilnosti, partneri, povelja, međunarodne prilike i informacije za odlazne i dolazne učesnike.",
    pageType: "WebPage",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Međunarodna saradnja",
        path: "/medjunarodna-saradnja",
      },
      {
        name: "Erasmus+",
        path: "/erasmus",
      },
    ],
  },
  "/erasmus-konkursi": {
    title: "Erasmus konkursi | FPEP Bar",
    description:
      "Aktuelni Erasmus konkursi na FPEP Bar: mobilnosti za studente, nastavno i nenastavno osoblje, uslovi prijave i prateća dokumentacija.",
    pageType: "CollectionPage",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Međunarodna saradnja",
        path: "/medjunarodna-saradnja",
      },
      {
        name: "Erasmus konkursi",
        path: "/erasmus-konkursi",
      },
    ],
  },
  "/finansijska-trzista-berzansko-poslovanje-rfb": {
    title:
      "Finansijska tržišta i berzansko poslovanje | Računovodstvo, finansije i bankarstvo | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Finansijska tržišta i berzansko poslovanje" na programu Računovodstvo, finansije i bankarstvo (Osnovne studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Računovodstvo, finansije i bankarstvo",
        path: "/racunovodstvo-finansije-i-bankarstvo",
      },
      {
        name: "Finansijska tržišta i berzansko poslovanje",
        path: "/finansijska-trzista-berzansko-poslovanje-rfb",
      },
    ],
    courseTitle: "Finansijska tržišta i berzansko poslovanje",
    programName: "Računovodstvo, finansije i bankarstvo",
    studyLevel: "Osnovne studije",
  },
  "/finansijsko-pravo-pm": {
    title: "Finansijsko pravo | Pravo | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Finansijsko pravo" na programu Pravo (Master studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Pravo",
        path: "/pravo-master",
      },
      {
        name: "Finansijsko pravo",
        path: "/finansijsko-pravo-pm",
      },
    ],
    courseTitle: "Finansijsko pravo",
    programName: "Pravo",
    studyLevel: "Master studije",
  },
  "/fiskalni-i-carinski-menadzment-ejs": {
    title:
      "Fiskalni i carinski menadžment | Ekonomija javnog sektora | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Fiskalni i carinski menadžment" na programu Ekonomija javnog sektora (Master studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Ekonomija javnog sektora",
        path: "/ekonomija-javnog-sektora",
      },
      {
        name: "Fiskalni i carinski menadžment",
        path: "/fiskalni-i-carinski-menadzment-ejs",
      },
    ],
    courseTitle: "Fiskalni i carinski menadžment",
    programName: "Ekonomija javnog sektora",
    studyLevel: "Master studije",
  },
  "/fiskalni-i-carinski-menadzment-pem": {
    title: "Fiskalni i carinski menadžment | Poslovna ekonomija | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Fiskalni i carinski menadžment" na programu Poslovna ekonomija (Master studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Poslovna ekonomija",
        path: "/poslovna-ekonomija",
      },
      {
        name: "Fiskalni i carinski menadžment",
        path: "/fiskalni-i-carinski-menadzment-pem",
      },
    ],
    courseTitle: "Fiskalni i carinski menadžment",
    programName: "Poslovna ekonomija",
    studyLevel: "Master studije",
  },
  "/galerija": {
    title: "Galerija | FPEP Bar",
    description:
      "Galerija Fakulteta za poslovnu ekonomiju i pravo Bar — fotografije događaja, studentskih aktivnosti, akademskih dešavanja i institucionalnog života.",
    pageType: "CollectionPage",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Galerija",
        path: "/galerija",
      },
    ],
  },
  "/gradjansko-pravo": {
    title: "Građansko pravo opšti dio i stvarno pravo | Pravo | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Građansko pravo opšti dio i stvarno pravo" na programu Pravo (Osnovne studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Pravo",
        path: "/pravo-osnovne",
      },
      {
        name: "Građansko pravo opšti dio i stvarno pravo",
        path: "/gradjansko-pravo",
      },
    ],
    courseTitle: "Građansko pravo opšti dio i stvarno pravo",
    programName: "Pravo",
    studyLevel: "Osnovne studije",
  },
  "/gradjansko-procesno-pravo-poas": {
    title: "Građansko procesno pravo | Pravo | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Građansko procesno pravo" na programu Pravo (Osnovne studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Pravo",
        path: "/pravo-osnovne",
      },
      {
        name: "Građansko procesno pravo",
        path: "/gradjansko-procesno-pravo-poas",
      },
    ],
    courseTitle: "Građansko procesno pravo",
    programName: "Pravo",
    studyLevel: "Osnovne studije",
  },
  "/informacione-tehnologije-poas": {
    title: "Informacione tehnologije | Pravo | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Informacione tehnologije" na programu Pravo (Osnovne studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Pravo",
        path: "/pravo-osnovne",
      },
      {
        name: "Informacione tehnologije",
        path: "/informacione-tehnologije-poas",
      },
    ],
    courseTitle: "Informacione tehnologije",
    programName: "Pravo",
    studyLevel: "Osnovne studije",
  },
  "/istorija-prava-poas": {
    title: "Istorija prava | Pravo | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Istorija prava" na programu Pravo (Osnovne studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Pravo",
        path: "/pravo-osnovne",
      },
      {
        name: "Istorija prava",
        path: "/istorija-prava-poas",
      },
    ],
    courseTitle: "Istorija prava",
    programName: "Pravo",
    studyLevel: "Osnovne studije",
  },
  "/izdavacka-djelatnost": {
    title: "Izdavačka djelatnost | FPEP Bar",
    description:
      "Izdavačka djelatnost FPEP Bar: publikacije, zbornici, časopisi i doprinos razvoju akademske i naučne produkcije.",
    pageType: "WebPage",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Pravni akti",
        path: "/o-nama",
      },
      {
        name: "Izdavačka djelatnost",
        path: "/izdavacka-djelatnost",
      },
    ],
  },
  "/kompanijsko-pravo-poas": {
    title: "Kompanijsko pravo | Pravo | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Kompanijsko pravo" na programu Pravo (Osnovne studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Pravo",
        path: "/pravo-osnovne",
      },
      {
        name: "Kompanijsko pravo",
        path: "/kompanijsko-pravo-poas",
      },
    ],
    courseTitle: "Kompanijsko pravo",
    programName: "Pravo",
    studyLevel: "Osnovne studije",
  },
  "/kontakt": {
    title: "Kontakt | FPEP Bar",
    description:
      "Kontaktirajte FPEP Bar — adresa, telefon, e-mail, mapa lokacije i korisne informacije za buduće studente, partnere i saradnike.",
    pageType: "ContactPage",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Kontakt",
        path: "/kontakt",
      },
    ],
  },
  "/kontrola-i-revizija-rfb": {
    title:
      "Kontrola i revizija | Računovodstvo, finansije i bankarstvo | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Kontrola i revizija" na programu Računovodstvo, finansije i bankarstvo (Osnovne studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Računovodstvo, finansije i bankarstvo",
        path: "/racunovodstvo-finansije-i-bankarstvo",
      },
      {
        name: "Kontrola i revizija",
        path: "/kontrola-i-revizija-rfb",
      },
    ],
    courseTitle: "Kontrola i revizija",
    programName: "Računovodstvo, finansije i bankarstvo",
    studyLevel: "Osnovne studije",
  },
  "/kontrola-revizija-m": {
    title: "Kontrola i revizija | Menadžment | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Kontrola i revizija" na programu Menadžment (Osnovne studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Menadžment",
        path: "/menadzment",
      },
      {
        name: "Kontrola i revizija",
        path: "/kontrola-revizija-m",
      },
    ],
    courseTitle: "Kontrola i revizija",
    programName: "Menadžment",
    studyLevel: "Osnovne studije",
  },
  "/korporativno-upravljanje-ejs": {
    title: "Korporativno upravljanje | Ekonomija javnog sektora | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Korporativno upravljanje" na programu Ekonomija javnog sektora (Master studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Ekonomija javnog sektora",
        path: "/ekonomija-javnog-sektora",
      },
      {
        name: "Korporativno upravljanje",
        path: "/korporativno-upravljanje-ejs",
      },
    ],
    courseTitle: "Korporativno upravljanje",
    programName: "Ekonomija javnog sektora",
    studyLevel: "Master studije",
  },
  "/korporativno-upravljanje-pem": {
    title: "Korporativno upravljanje | Poslovna ekonomija | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Korporativno upravljanje" na programu Poslovna ekonomija (Master studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Poslovna ekonomija",
        path: "/poslovna-ekonomija",
      },
      {
        name: "Korporativno upravljanje",
        path: "/korporativno-upravljanje-pem",
      },
    ],
    courseTitle: "Korporativno upravljanje",
    programName: "Poslovna ekonomija",
    studyLevel: "Master studije",
  },
  "/korporativno-upravljanje-pm": {
    title: "Korporativno upravljanje | Pravo | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Korporativno upravljanje" na programu Pravo (Master studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Pravo",
        path: "/pravo-master",
      },
      {
        name: "Korporativno upravljanje",
        path: "/korporativno-upravljanje-pm",
      },
    ],
    courseTitle: "Korporativno upravljanje",
    programName: "Pravo",
    studyLevel: "Master studije",
  },
  "/krivicno-pravo-poas": {
    title: "Krivično pravo - opšti i posebni dio | Pravo | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Krivično pravo - opšti i posebni dio" na programu Pravo (Osnovne studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Pravo",
        path: "/pravo-osnovne",
      },
      {
        name: "Krivično pravo - opšti i posebni dio",
        path: "/krivicno-pravo-poas",
      },
    ],
    courseTitle: "Krivično pravo - opšti i posebni dio",
    programName: "Pravo",
    studyLevel: "Osnovne studije",
  },
  "/krivicno-procesno-pravo-poas": {
    title: "Krivično procesno pravo | Pravo | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Krivično procesno pravo" na programu Pravo (Osnovne studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Pravo",
        path: "/pravo-osnovne",
      },
      {
        name: "Krivično procesno pravo",
        path: "/krivicno-procesno-pravo-poas",
      },
    ],
    courseTitle: "Krivično procesno pravo",
    programName: "Pravo",
    studyLevel: "Osnovne studije",
  },
  "/liderstvo-ejs": {
    title: "Liderstvo | Ekonomija javnog sektora | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Liderstvo" na programu Ekonomija javnog sektora (Master studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Ekonomija javnog sektora",
        path: "/ekonomija-javnog-sektora",
      },
      {
        name: "Liderstvo",
        path: "/liderstvo-ejs",
      },
    ],
    courseTitle: "Liderstvo",
    programName: "Ekonomija javnog sektora",
    studyLevel: "Master studije",
  },
  "/liderstvo-pem": {
    title: "Liderstvo | Poslovna ekonomija | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Liderstvo" na programu Poslovna ekonomija (Master studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Poslovna ekonomija",
        path: "/poslovna-ekonomija",
      },
      {
        name: "Liderstvo",
        path: "/liderstvo-pem",
      },
    ],
    courseTitle: "Liderstvo",
    programName: "Poslovna ekonomija",
    studyLevel: "Master studije",
  },
  "/ljudksa-prava-i-slobode-poas": {
    title: "Ljudska prava i slobode | Pravo | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Ljudska prava i slobode" na programu Pravo (Osnovne studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Pravo",
        path: "/pravo-osnovne",
      },
      {
        name: "Ljudska prava i slobode",
        path: "/ljudksa-prava-i-slobode-poas",
      },
    ],
    courseTitle: "Ljudska prava i slobode",
    programName: "Pravo",
    studyLevel: "Osnovne studije",
  },
  "/logistika-m": {
    title: "Logistika | Menadžment | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Logistika" na programu Menadžment (Osnovne studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Menadžment",
        path: "/menadzment",
      },
      {
        name: "Logistika",
        path: "/logistika-m",
      },
    ],
    courseTitle: "Logistika",
    programName: "Menadžment",
    studyLevel: "Osnovne studije",
  },
  "/logistika-rfb": {
    title: "Logistika | Računovodstvo, finansije i bankarstvo | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Logistika" na programu Računovodstvo, finansije i bankarstvo (Osnovne studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Računovodstvo, finansije i bankarstvo",
        path: "/racunovodstvo-finansije-i-bankarstvo",
      },
      {
        name: "Logistika",
        path: "/logistika-rfb",
      },
    ],
    courseTitle: "Logistika",
    programName: "Računovodstvo, finansije i bankarstvo",
    studyLevel: "Osnovne studije",
  },
  "/maloljetnicko-krivicno-pravo-pm": {
    title: "Maloljetničko krivično pravo | Pravo | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Maloljetničko krivično pravo" na programu Pravo (Master studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Pravo",
        path: "/pravo-master",
      },
      {
        name: "Maloljetničko krivično pravo",
        path: "/maloljetnicko-krivicno-pravo-pm",
      },
    ],
    courseTitle: "Maloljetničko krivično pravo",
    programName: "Pravo",
    studyLevel: "Master studije",
  },
  "/marketing-m": {
    title: "Marketing | Menadžment | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Marketing" na programu Menadžment (Osnovne studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Menadžment",
        path: "/menadzment",
      },
      {
        name: "Marketing",
        path: "/marketing-m",
      },
    ],
    courseTitle: "Marketing",
    programName: "Menadžment",
    studyLevel: "Osnovne studije",
  },
  "/marketing-menadzment-ejs": {
    title: "Marketing menadžment | Ekonomija javnog sektora | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Marketing menadžment" na programu Ekonomija javnog sektora (Master studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Ekonomija javnog sektora",
        path: "/ekonomija-javnog-sektora",
      },
      {
        name: "Marketing menadžment",
        path: "/marketing-menadzment-ejs",
      },
    ],
    courseTitle: "Marketing menadžment",
    programName: "Ekonomija javnog sektora",
    studyLevel: "Master studije",
  },
  "/marketing-menadzment-pem": {
    title: "Marketing menadžment | Poslovna ekonomija | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Marketing menadžment" na programu Poslovna ekonomija (Master studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Poslovna ekonomija",
        path: "/poslovna-ekonomija",
      },
      {
        name: "Marketing menadžment",
        path: "/marketing-menadzment-pem",
      },
    ],
    courseTitle: "Marketing menadžment",
    programName: "Poslovna ekonomija",
    studyLevel: "Master studije",
  },
  "/marketing-rfb": {
    title: "Marketing | Računovodstvo, finansije i bankarstvo | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Marketing" na programu Računovodstvo, finansije i bankarstvo (Osnovne studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Računovodstvo, finansije i bankarstvo",
        path: "/racunovodstvo-finansije-i-bankarstvo",
      },
      {
        name: "Marketing",
        path: "/marketing-rfb",
      },
    ],
    courseTitle: "Marketing",
    programName: "Računovodstvo, finansije i bankarstvo",
    studyLevel: "Osnovne studije",
  },
  "/matematicko-statisticke-metode-m": {
    title: "Matematičko-statističke metode | Menadžment | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Matematičko-statističke metode" na programu Menadžment (Osnovne studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Menadžment",
        path: "/menadzment",
      },
      {
        name: "Matematičko-statističke metode",
        path: "/matematicko-statisticke-metode-m",
      },
    ],
    courseTitle: "Matematičko-statističke metode",
    programName: "Menadžment",
    studyLevel: "Osnovne studije",
  },
  "/matematicko-statisticke-metode-rfb": {
    title:
      "Matematičko-statističke metode | Računovodstvo, finansije i bankarstvo | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Matematičko-statističke metode" na programu Računovodstvo, finansije i bankarstvo (Osnovne studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Računovodstvo, finansije i bankarstvo",
        path: "/racunovodstvo-finansije-i-bankarstvo",
      },
      {
        name: "Matematičko-statističke metode",
        path: "/matematicko-statisticke-metode-rfb",
      },
    ],
    courseTitle: "Matematičko-statističke metode",
    programName: "Računovodstvo, finansije i bankarstvo",
    studyLevel: "Osnovne studije",
  },
  "/medjunarodna-saradnja": {
    title: "Međunarodna saradnja | FPEP Bar",
    description:
      "Međunarodna saradnja FPEP Bar: Erasmus+, partnerstva, projekti, mobilnosti, informacije za strane studente i međunarodne akademske aktivnosti.",
    pageType: "CollectionPage",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Međunarodna saradnja",
        path: "/medjunarodna-saradnja",
      },
    ],
  },
  "/medjunarodne-organizacije-pm": {
    title: "Međunarodne organizacije | Pravo | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Međunarodne organizacije" na programu Pravo (Master studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Pravo",
        path: "/pravo-master",
      },
      {
        name: "Međunarodne organizacije",
        path: "/medjunarodne-organizacije-pm",
      },
    ],
    courseTitle: "Međunarodne organizacije",
    programName: "Pravo",
    studyLevel: "Master studije",
  },
  "/medjunarodno-gradjansko-procesno-pravo-pm": {
    title: "Međunarodno građansko procesno pravo | Pravo | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Međunarodno građansko procesno pravo" na programu Pravo (Master studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Pravo",
        path: "/pravo-master",
      },
      {
        name: "Međunarodno građansko procesno pravo",
        path: "/medjunarodno-gradjansko-procesno-pravo-pm",
      },
    ],
    courseTitle: "Međunarodno građansko procesno pravo",
    programName: "Pravo",
    studyLevel: "Master studije",
  },
  "/medjunarodno-javno-pravo-poas": {
    title: "Međunarodno javno pravo | Pravo | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Međunarodno javno pravo" na programu Pravo (Osnovne studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Pravo",
        path: "/pravo-osnovne",
      },
      {
        name: "Međunarodno javno pravo",
        path: "/medjunarodno-javno-pravo-poas",
      },
    ],
    courseTitle: "Međunarodno javno pravo",
    programName: "Pravo",
    studyLevel: "Osnovne studije",
  },
  "/medjunarodno-krivicno-pravo-pm": {
    title: "Međunarodno krivično pravo | Pravo | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Međunarodno krivično pravo" na programu Pravo (Master studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Pravo",
        path: "/pravo-master",
      },
      {
        name: "Međunarodno krivično pravo",
        path: "/medjunarodno-krivicno-pravo-pm",
      },
    ],
    courseTitle: "Međunarodno krivično pravo",
    programName: "Pravo",
    studyLevel: "Master studije",
  },
  "/medjunarodno-poslovanje-ejs": {
    title: "Međunarodno poslovanje | Ekonomija javnog sektora | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Međunarodno poslovanje" na programu Ekonomija javnog sektora (Master studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Ekonomija javnog sektora",
        path: "/ekonomija-javnog-sektora",
      },
      {
        name: "Međunarodno poslovanje",
        path: "/medjunarodno-poslovanje-ejs",
      },
    ],
    courseTitle: "Međunarodno poslovanje",
    programName: "Ekonomija javnog sektora",
    studyLevel: "Master studije",
  },
  "/medjunarodno-poslovanje-pem": {
    title: "Međunarodno poslovanje | Poslovna ekonomija | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Međunarodno poslovanje" na programu Poslovna ekonomija (Master studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Poslovna ekonomija",
        path: "/poslovna-ekonomija",
      },
      {
        name: "Međunarodno poslovanje",
        path: "/medjunarodno-poslovanje-pem",
      },
    ],
    courseTitle: "Međunarodno poslovanje",
    programName: "Poslovna ekonomija",
    studyLevel: "Master studije",
  },
  "/medjunarodno-privredno-pravo-ejs": {
    title: "Međunarodno privredno pravo | Ekonomija javnog sektora | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Međunarodno privredno pravo" na programu Ekonomija javnog sektora (Master studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Ekonomija javnog sektora",
        path: "/ekonomija-javnog-sektora",
      },
      {
        name: "Međunarodno privredno pravo",
        path: "/medjunarodno-privredno-pravo-ejs",
      },
    ],
    courseTitle: "Međunarodno privredno pravo",
    programName: "Ekonomija javnog sektora",
    studyLevel: "Master studije",
  },
  "/medjunarodno-privredno-pravo-pem": {
    title: "Međunarodno privredno pravo | Poslovna ekonomija | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Međunarodno privredno pravo" na programu Poslovna ekonomija (Master studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Poslovna ekonomija",
        path: "/poslovna-ekonomija",
      },
      {
        name: "Međunarodno privredno pravo",
        path: "/medjunarodno-privredno-pravo-pem",
      },
    ],
    courseTitle: "Međunarodno privredno pravo",
    programName: "Poslovna ekonomija",
    studyLevel: "Master studije",
  },
  "/medjunarodno-privredno-pravo-pm": {
    title: "Međunarodno privredno pravo | Pravo | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Međunarodno privredno pravo" na programu Pravo (Master studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Pravo",
        path: "/pravo-master",
      },
      {
        name: "Međunarodno privredno pravo",
        path: "/medjunarodno-privredno-pravo-pm",
      },
    ],
    courseTitle: "Međunarodno privredno pravo",
    programName: "Pravo",
    studyLevel: "Master studije",
  },
  "/medjunarodno-procesno-pravo-poas": {
    title: "Međunarodno procesno pravo | Pravo | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Međunarodno procesno pravo" na programu Pravo (Osnovne studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Pravo",
        path: "/pravo-osnovne",
      },
      {
        name: "Međunarodno procesno pravo",
        path: "/medjunarodno-procesno-pravo-poas",
      },
    ],
    courseTitle: "Međunarodno procesno pravo",
    programName: "Pravo",
    studyLevel: "Osnovne studije",
  },
  "/menadzment": {
    title: "Menadžment | FPEP Bar",
    description:
      "Studijski program osnovnih akademskih studija 'Menadžment' na Fakultetu za poslovnu ekonomiju i pravo Bar osmišljen je da studentima pruži sveobuhvatno znanje…",
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Menadžment",
        path: "/menadzment",
      },
    ],
  },
  "/menadzment-bezbjednosti-m": {
    title: "Menadžment bezbjednosti | Menadžment | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Menadžment bezbjednosti" na programu Menadžment (Osnovne studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Menadžment",
        path: "/menadzment",
      },
      {
        name: "Menadžment bezbjednosti",
        path: "/menadzment-bezbjednosti-m",
      },
    ],
    courseTitle: "Menadžment bezbjednosti",
    programName: "Menadžment",
    studyLevel: "Osnovne studije",
  },
  "/menadzment-javnog-sektora-specijalisticke": {
    title: "Menadžment javnog sektora – specijalističke studije | FPEP Bar",
    description:
      "Jednogodišnji akademski specijalistički program (VII/1) osposobljava te za strateško vođenje institucija javne uprave i lokalne samouprave, uz čvrst pravni i…",
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Menadžment javnog sektora",
        path: "/menadzment-javnog-sektora-specijalisticke",
      },
    ],
  },
  "/menadzment-ljudskih-resursa-m": {
    title: "Menadžment ljudskih resursa | Menadžment | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Menadžment ljudskih resursa" na programu Menadžment (Osnovne studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Menadžment",
        path: "/menadzment",
      },
      {
        name: "Menadžment ljudskih resursa",
        path: "/menadzment-ljudskih-resursa-m",
      },
    ],
    courseTitle: "Menadžment ljudskih resursa",
    programName: "Menadžment",
    studyLevel: "Osnovne studije",
  },
  "/menadzment-ljudskih-resursa-rfb": {
    title:
      "Menadžment ljudskih resursa | Računovodstvo, finansije i bankarstvo | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Menadžment ljudskih resursa" na programu Računovodstvo, finansije i bankarstvo (Osnovne studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Računovodstvo, finansije i bankarstvo",
        path: "/racunovodstvo-finansije-i-bankarstvo",
      },
      {
        name: "Menadžment ljudskih resursa",
        path: "/menadzment-ljudskih-resursa-rfb",
      },
    ],
    courseTitle: "Menadžment ljudskih resursa",
    programName: "Računovodstvo, finansije i bankarstvo",
    studyLevel: "Osnovne studije",
  },
  "/menadzment-m": {
    title: "Menadžment | Menadžment | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Menadžment" na programu Menadžment (Osnovne studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Menadžment",
        path: "/menadzment",
      },
      {
        name: "Menadžment",
        path: "/menadzment-m",
      },
    ],
    courseTitle: "Menadžment",
    programName: "Menadžment",
    studyLevel: "Osnovne studije",
  },
  "/menadzment-malih-srednjih-preduzeca-m": {
    title: "Menadžment malih i srednjih preduzeća | Menadžment | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Menadžment malih i srednjih preduzeća" na programu Menadžment (Osnovne studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Menadžment",
        path: "/menadzment",
      },
      {
        name: "Menadžment malih i srednjih preduzeća",
        path: "/menadzment-malih-srednjih-preduzeca-m",
      },
    ],
    courseTitle: "Menadžment malih i srednjih preduzeća",
    programName: "Menadžment",
    studyLevel: "Osnovne studije",
  },
  "/menadzment-malih-srednjih-preduzeca-rfb": {
    title:
      "Menadžment malih i srednjih preduzeća | Računovodstvo, finansije i bankarstvo | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Menadžment malih i srednjih preduzeća" na programu Računovodstvo, finansije i bankarstvo (Osnovne studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Računovodstvo, finansije i bankarstvo",
        path: "/racunovodstvo-finansije-i-bankarstvo",
      },
      {
        name: "Menadžment malih i srednjih preduzeća",
        path: "/menadzment-malih-srednjih-preduzeca-rfb",
      },
    ],
    courseTitle: "Menadžment malih i srednjih preduzeća",
    programName: "Računovodstvo, finansije i bankarstvo",
    studyLevel: "Osnovne studije",
  },
  "/menadzment-neprofitnih-organizacija-ejs": {
    title:
      "Menadžment neprofitnih organizacija | Ekonomija javnog sektora | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Menadžment neprofitnih organizacija" na programu Ekonomija javnog sektora (Master studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Ekonomija javnog sektora",
        path: "/ekonomija-javnog-sektora",
      },
      {
        name: "Menadžment neprofitnih organizacija",
        path: "/menadzment-neprofitnih-organizacija-ejs",
      },
    ],
    courseTitle: "Menadžment neprofitnih organizacija",
    programName: "Ekonomija javnog sektora",
    studyLevel: "Master studije",
  },
  "/menadzment-obrazovanja-i-kulture-ejs": {
    title:
      "Menadžment obrazovanja i kulture | Ekonomija javnog sektora | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Menadžment obrazovanja i kulture" na programu Ekonomija javnog sektora (Master studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Ekonomija javnog sektora",
        path: "/ekonomija-javnog-sektora",
      },
      {
        name: "Menadžment obrazovanja i kulture",
        path: "/menadzment-obrazovanja-i-kulture-ejs",
      },
    ],
    courseTitle: "Menadžment obrazovanja i kulture",
    programName: "Ekonomija javnog sektora",
    studyLevel: "Master studije",
  },
  "/menadzment-predmet-rfb": {
    title: "Menadžment | Računovodstvo, finansije i bankarstvo | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Menadžment" na programu Računovodstvo, finansije i bankarstvo (Osnovne studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Računovodstvo, finansije i bankarstvo",
        path: "/racunovodstvo-finansije-i-bankarstvo",
      },
      {
        name: "Menadžment",
        path: "/menadzment-predmet-rfb",
      },
    ],
    courseTitle: "Menadžment",
    programName: "Računovodstvo, finansije i bankarstvo",
    studyLevel: "Osnovne studije",
  },
  "/menadzment-profitnog-sektora-specijalisticke": {
    title: "Menadžment profitnog sektora – specijalističke studije | FPEP Bar",
    description:
      "Ovaj jednogodišnji program (VII/1) je fokusiran na rast i konkurentnost kompanija.",
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Menadžment profitnog sektora",
        path: "/menadzment-profitnog-sektora-specijalisticke",
      },
    ],
  },
  "/menadzment-u-sportu-rfb": {
    title:
      "Menadžment u sportu | Računovodstvo, finansije i bankarstvo | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Menadžment u sportu" na programu Računovodstvo, finansije i bankarstvo (Osnovne studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Računovodstvo, finansije i bankarstvo",
        path: "/racunovodstvo-finansije-i-bankarstvo",
      },
      {
        name: "Menadžment u sportu",
        path: "/menadzment-u-sportu-rfb",
      },
    ],
    courseTitle: "Menadžment u sportu",
    programName: "Računovodstvo, finansije i bankarstvo",
    studyLevel: "Osnovne studije",
  },
  "/metodologija-naucno-istrazivackog-rada-ejs": {
    title:
      "Metodologija naučno-istraživačkog rada | Ekonomija javnog sektora | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Metodologija naučno-istraživačkog rada" na programu Ekonomija javnog sektora (Master studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Ekonomija javnog sektora",
        path: "/ekonomija-javnog-sektora",
      },
      {
        name: "Metodologija naučno-istraživačkog rada",
        path: "/metodologija-naucno-istrazivackog-rada-ejs",
      },
    ],
    courseTitle: "Metodologija naučno-istraživačkog rada",
    programName: "Ekonomija javnog sektora",
    studyLevel: "Master studije",
  },
  "/metodologija-naucno-istrazivackog-rada-pem": {
    title:
      "Metodologija naučno-istraživačkog rada | Poslovna ekonomija | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Metodologija naučno-istraživačkog rada" na programu Poslovna ekonomija (Master studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Poslovna ekonomija",
        path: "/poslovna-ekonomija",
      },
      {
        name: "Metodologija naučno-istraživačkog rada",
        path: "/metodologija-naucno-istrazivackog-rada-pem",
      },
    ],
    courseTitle: "Metodologija naučno-istraživačkog rada",
    programName: "Poslovna ekonomija",
    studyLevel: "Master studije",
  },
  "/metodologija-naucno-istrazivackog-rada-pm": {
    title: "Metodologija naučno-istraživačkog rada | Pravo | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Metodologija naučno-istraživačkog rada" na programu Pravo (Master studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Pravo",
        path: "/pravo-master",
      },
      {
        name: "Metodologija naučno-istraživačkog rada",
        path: "/metodologija-naucno-istrazivackog-rada-pm",
      },
    ],
    courseTitle: "Metodologija naučno-istraživačkog rada",
    programName: "Pravo",
    studyLevel: "Master studije",
  },
  "/misija-vizija-i-vrijednosti": {
    title: "Misija, vizija i vrijednosti | FPEP Bar",
    description:
      "Misija, vizija i vrijednosti Fakulteta za poslovnu ekonomiju i pravo Bar — strateško opredjeljenje, akademska kultura i razvojne smjernice ustanove.",
    pageType: "AboutPage",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "O nama",
        path: "/o-nama",
      },
      {
        name: "Misija, vizija i vrijednosti",
        path: "/misija-vizija-i-vrijednosti",
      },
    ],
  },
  "/model-studentske-prakse": {
    title: "Model studentske prakse | FPEP Bar",
    description:
      "Model studentske prakse na FPEP Bar: stručna praksa, praktična nastava, povezivanje studija sa tržištem rada i razvoj primjenjivih vještina.",
    pageType: "WebPage",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Pravni akti",
        path: "/o-nama",
      },
      {
        name: "Model studentske prakse",
        path: "/model-studentske-prakse",
      },
    ],
  },
  "/monetarne-i-javne-finansije-rfb": {
    title:
      "Monetarne i javne finansije | Računovodstvo, finansije i bankarstvo | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Monetarne i javne finansije" na programu Računovodstvo, finansije i bankarstvo (Osnovne studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Računovodstvo, finansije i bankarstvo",
        path: "/racunovodstvo-finansije-i-bankarstvo",
      },
      {
        name: "Monetarne i javne finansije",
        path: "/monetarne-i-javne-finansije-rfb",
      },
    ],
    courseTitle: "Monetarne i javne finansije",
    programName: "Računovodstvo, finansije i bankarstvo",
    studyLevel: "Osnovne studije",
  },
  "/najcesca-pitanja": {
    title: "Najčešća pitanja | FPEP Bar",
    description:
      "Najčešća pitanja o upisu, studiranju, dokumentaciji, školarini i studentskom životu na Fakultetu za poslovnu ekonomiju i pravo Bar.",
    pageType: "FAQPage",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "O nama",
        path: "/o-nama",
      },
      {
        name: "Najčešća pitanja",
        path: "/najcesca-pitanja",
      },
    ],
  },
  "/nasljedno-pravo-poas": {
    title: "Nasljedno pravo | Pravo | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Nasljedno pravo" na programu Pravo (Osnovne studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Pravo",
        path: "/pravo-osnovne",
      },
      {
        name: "Nasljedno pravo",
        path: "/nasljedno-pravo-poas",
      },
    ],
    courseTitle: "Nasljedno pravo",
    programName: "Pravo",
    studyLevel: "Osnovne studije",
  },
  "/nastavno-osoblje": {
    title: "Nastavno osoblje | FPEP Bar",
    description:
      "Pregled nastavnog osoblja FPEP Bar — profesori, saradnici i akademski kadar uključen u realizaciju studijskih programa i naučni razvoj ustanove.",
    pageType: "WebPage",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "O nama",
        path: "/o-nama",
      },
      {
        name: "Nastavno osoblje",
        path: "/nastavno-osoblje",
      },
    ],
  },
  "/naucnoistrazivacki-rad": {
    title: "Naučnoistraživački rad | FPEP Bar",
    description:
      "Naučnoistraživački rad na FPEP Bar: licence, istraživački kapaciteti, projekti i razvoj naučne aktivnosti u oblastima ekonomije i prava.",
    pageType: "WebPage",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Pravni akti",
        path: "/o-nama",
      },
      {
        name: "Naučnoistraživački rad",
        path: "/naucnoistrazivacki-rad",
      },
    ],
  },
  "/notarsko-advokatsko-pravo-poas": {
    title: "Notarsko i advokatsko pravo | Pravo | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Notarsko i advokatsko pravo" na programu Pravo (Osnovne studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Pravo",
        path: "/pravo-osnovne",
      },
      {
        name: "Notarsko i advokatsko pravo",
        path: "/notarsko-advokatsko-pravo-poas",
      },
    ],
    courseTitle: "Notarsko i advokatsko pravo",
    programName: "Pravo",
    studyLevel: "Osnovne studije",
  },
  "/novosti": {
    title: "Novosti | FPEP Bar",
    description:
      "Aktuelne novosti FPEP Bar: vijesti, saopštenja, studentske aktivnosti, međunarodni projekti, događaji i objave važne za buduće i sadašnje studente.",
    pageType: "CollectionPage",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Novosti",
        path: "/novosti",
      },
    ],
  },
  "/novosti/:id": {
    title: "Novost | FPEP Bar",
    description:
      "Pročitajte objavu, saopštenje ili vijest Fakulteta za poslovnu ekonomiju i pravo Bar.",
    pageType: "Article",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Novosti",
        path: "/novosti",
      },
    ],
  },
  "/o-baru": {
    title: "O Baru | FPEP Bar",
    description:
      "Informacije o Baru za međunarodne studente i goste FPEP Bar — lokacija, okruženje, studentski kontekst i korisne smjernice za boravak u gradu.",
    pageType: "WebPage",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Međunarodna saradnja",
        path: "/medjunarodna-saradnja",
      },
      {
        name: "O Baru",
        path: "/o-baru",
      },
    ],
  },
  "/o-crnoj-gori": {
    title: "O Crnoj Gori | FPEP Bar",
    description:
      "Praktične informacije o Crnoj Gori za međunarodne studente i partnere FPEP Bar — osnovne činjenice, kontekst i korisne smjernice.",
    pageType: "WebPage",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Međunarodna saradnja",
        path: "/medjunarodna-saradnja",
      },
      {
        name: "O Crnoj Gori",
        path: "/o-crnoj-gori",
      },
    ],
  },
  "/o-fpep": {
    title: "O FPEP-u | FPEP Bar",
    description:
      "Saznajte više o Fakultetu za poslovnu ekonomiju i pravo Bar, njegovom identitetu, razvoju, akademskim vrijednostima i institucionalnom pozicioniranju.",
    pageType: "AboutPage",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "O nama",
        path: "/o-nama",
      },
      {
        name: "O FPEP-u",
        path: "/o-fpep",
      },
    ],
  },
  "/o-nama": {
    title: "O nama | FPEP Bar",
    description:
      "Saznajte više o Fakultetu za poslovnu ekonomiju i pravo Bar, njegovom razvoju, misiji, viziji, rukovodstvu i institucionalnim vrijednostima.",
    pageType: "AboutPage",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "O nama",
        path: "/o-nama",
      },
    ],
  },
  "/o-univerzitetu": {
    title: "O Univerzitetu | FPEP Bar",
    description:
      "Informacije o Univerzitetu Adriatik Bar, institucionalnom okviru, akademskom razvoju i ulozi FPEP Bar u okviru univerzitetske zajednice.",
    pageType: "AboutPage",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "O nama",
        path: "/o-nama",
      },
      {
        name: "O Univerzitetu",
        path: "/o-univerzitetu",
      },
    ],
  },
  "/obezbjedjivanje-kvaliteta": {
    title: "Obezbjeđivanje kvaliteta | FPEP Bar",
    description:
      "Sistem obezbjeđivanja kvaliteta na FPEP Bar: standardi, procedure, dokumenta i strateški pristup unapređenju nastavnog procesa.",
    pageType: "WebPage",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Pravni akti",
        path: "/o-nama",
      },
      {
        name: "Obezbjeđivanje kvaliteta",
        path: "/obezbjedjivanje-kvaliteta",
      },
    ],
  },
  "/obezbjedjivanje-kvaliteta/ankete": {
    title: "Ankete za obezbjeđivanje kvaliteta | FPEP Bar",
    description:
      "Ankete FPEP Bar namijenjene studentima i drugim učesnicima nastavnog procesa, kao dio kontinuiranog praćenja i unapređivanja kvaliteta.",
    pageType: "WebPage",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Obezbjeđivanje kvaliteta",
        path: "/obezbjedjivanje-kvaliteta",
      },
      {
        name: "Ankete",
        path: "/obezbjedjivanje-kvaliteta/ankete",
      },
    ],
  },
  "/obligaciono-pravo-poas": {
    title: "Obligaciono pravo | Pravo | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Obligaciono pravo" na programu Pravo (Osnovne studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Pravo",
        path: "/pravo-osnovne",
      },
      {
        name: "Obligaciono pravo",
        path: "/obligaciono-pravo-poas",
      },
    ],
    courseTitle: "Obligaciono pravo",
    programName: "Pravo",
    studyLevel: "Osnovne studije",
  },
  "/odrzivi-razvoj-i-ekoloski-menadzment-ejs": {
    title:
      "Održivi razvoj i ekološki menadžment | Ekonomija javnog sektora | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Održivi razvoj i ekološki menadžment" na programu Ekonomija javnog sektora (Master studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Ekonomija javnog sektora",
        path: "/ekonomija-javnog-sektora",
      },
      {
        name: "Održivi razvoj i ekološki menadžment",
        path: "/odrzivi-razvoj-i-ekoloski-menadzment-ejs",
      },
    ],
    courseTitle: "Održivi razvoj i ekološki menadžment",
    programName: "Ekonomija javnog sektora",
    studyLevel: "Master studije",
  },
  "/odrzivi-razvoj-m": {
    title: "Održivi razvoj | Menadžment | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Održivi razvoj" na programu Menadžment (Osnovne studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Menadžment",
        path: "/menadzment",
      },
      {
        name: "Održivi razvoj",
        path: "/odrzivi-razvoj-m",
      },
    ],
    courseTitle: "Održivi razvoj",
    programName: "Menadžment",
    studyLevel: "Osnovne studije",
  },
  "/organizacija-pravosudja-pm": {
    title: "Organizacija pravosuđa | Pravo | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Organizacija pravosuđa" na programu Pravo (Master studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Pravo",
        path: "/pravo-master",
      },
      {
        name: "Organizacija pravosuđa",
        path: "/organizacija-pravosudja-pm",
      },
    ],
    courseTitle: "Organizacija pravosuđa",
    programName: "Pravo",
    studyLevel: "Master studije",
  },
  "/osnivac": {
    title: "Osnivač | FPEP Bar",
    description:
      "Stranica posvećena osnivaču Fakulteta za poslovnu ekonomiju i pravo Bar i njegovoj ulozi u razvoju visokog obrazovanja u Baru.",
    pageType: "AboutPage",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "O nama",
        path: "/o-nama",
      },
      {
        name: "Osnivač",
        path: "/osnivac",
      },
    ],
  },
  "/osnovi-ekonomije-m": {
    title: "Osnovi ekonomije | Menadžment | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Osnovi ekonomije" na programu Menadžment (Osnovne studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Menadžment",
        path: "/menadzment",
      },
      {
        name: "Osnovi ekonomije",
        path: "/osnovi-ekonomije-m",
      },
    ],
    courseTitle: "Osnovi ekonomije",
    programName: "Menadžment",
    studyLevel: "Osnovne studije",
  },
  "/osnovi-ekonomije-poas": {
    title: "Osnovi ekonomije | Pravo | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Osnovi ekonomije" na programu Pravo (Osnovne studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Pravo",
        path: "/pravo-osnovne",
      },
      {
        name: "Osnovi ekonomije",
        path: "/osnovi-ekonomije-poas",
      },
    ],
    courseTitle: "Osnovi ekonomije",
    programName: "Pravo",
    studyLevel: "Osnovne studije",
  },
  "/osnovi-ekonomije-rfb": {
    title:
      "Osnovi ekonomije | Računovodstvo, finansije i bankarstvo | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Osnovi ekonomije" na programu Računovodstvo, finansije i bankarstvo (Osnovne studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Računovodstvo, finansije i bankarstvo",
        path: "/racunovodstvo-finansije-i-bankarstvo",
      },
      {
        name: "Osnovi ekonomije",
        path: "/osnovi-ekonomije-rfb",
      },
    ],
    courseTitle: "Osnovi ekonomije",
    programName: "Računovodstvo, finansije i bankarstvo",
    studyLevel: "Osnovne studije",
  },
  "/osnovi-kompanijskog-prava-poas": {
    title: "Osnovi kompanijskog prava i trgovinsko pravo | Pravo | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Osnovi kompanijskog prava i trgovinsko pravo" na programu Pravo (Osnovne studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Pravo",
        path: "/pravo-osnovne",
      },
      {
        name: "Osnovi kompanijskog prava i trgovinsko pravo",
        path: "/osnovi-kompanijskog-prava-poas",
      },
    ],
    courseTitle: "Osnovi kompanijskog prava i trgovinsko pravo",
    programName: "Pravo",
    studyLevel: "Osnovne studije",
  },
  "/osnovi-kompanijskog-trgovinskog-prava-m": {
    title: "Osnovi kompanijskog i trgovinskog prava | Menadžment | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Osnovi kompanijskog i trgovinskog prava" na programu Menadžment (Osnovne studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Menadžment",
        path: "/menadzment",
      },
      {
        name: "Osnovi kompanijskog i trgovinskog prava",
        path: "/osnovi-kompanijskog-trgovinskog-prava-m",
      },
    ],
    courseTitle: "Osnovi kompanijskog i trgovinskog prava",
    programName: "Menadžment",
    studyLevel: "Osnovne studije",
  },
  "/osnovi-kompanijskog-trgovinskog-prava-rfb": {
    title:
      "Osnovi kompanijskog i trgovinskog prava | Računovodstvo, finansije i bankarstvo | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Osnovi kompanijskog i trgovinskog prava" na programu Računovodstvo, finansije i bankarstvo (Osnovne studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Računovodstvo, finansije i bankarstvo",
        path: "/racunovodstvo-finansije-i-bankarstvo",
      },
      {
        name: "Osnovi kompanijskog i trgovinskog prava",
        path: "/osnovi-kompanijskog-trgovinskog-prava-rfb",
      },
    ],
    courseTitle: "Osnovi kompanijskog i trgovinskog prava",
    programName: "Računovodstvo, finansije i bankarstvo",
    studyLevel: "Osnovne studije",
  },
  "/osnovi-preduzetnistva-m": {
    title: "Osnovi preduzetništva | Menadžment | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Osnovi preduzetništva" na programu Menadžment (Osnovne studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Menadžment",
        path: "/menadzment",
      },
      {
        name: "Osnovi preduzetništva",
        path: "/osnovi-preduzetnistva-m",
      },
    ],
    courseTitle: "Osnovi preduzetništva",
    programName: "Menadžment",
    studyLevel: "Osnovne studije",
  },
  "/osnovi-preduzetnistva-rfb": {
    title:
      "Osnovi preduzetništva | Računovodstvo, finansije i bankarstvo | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Osnovi preduzetništva" na programu Računovodstvo, finansije i bankarstvo (Osnovne studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Računovodstvo, finansije i bankarstvo",
        path: "/racunovodstvo-finansije-i-bankarstvo",
      },
      {
        name: "Osnovi preduzetništva",
        path: "/osnovi-preduzetnistva-rfb",
      },
    ],
    courseTitle: "Osnovi preduzetništva",
    programName: "Računovodstvo, finansije i bankarstvo",
    studyLevel: "Osnovne studije",
  },
  "/porodicni-biznis-m": {
    title: "Porodični biznis | Menadžment | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Porodični biznis" na programu Menadžment (Osnovne studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Menadžment",
        path: "/menadzment",
      },
      {
        name: "Porodični biznis",
        path: "/porodicni-biznis-m",
      },
    ],
    courseTitle: "Porodični biznis",
    programName: "Menadžment",
    studyLevel: "Osnovne studije",
  },
  "/porodicno-pravo-poas": {
    title: "Porodično pravo | Pravo | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Porodično pravo" na programu Pravo (Osnovne studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Pravo",
        path: "/pravo-osnovne",
      },
      {
        name: "Porodično pravo",
        path: "/porodicno-pravo-poas",
      },
    ],
    courseTitle: "Porodično pravo",
    programName: "Pravo",
    studyLevel: "Osnovne studije",
  },
  "/poslovna-ekonomija": {
    title: "Poslovna ekonomija – master studije | FPEP Bar",
    description:
      "Program postdiplomskih akademskih studija 'Poslovna ekonomija' na Fakultetu za poslovnu ekonomiju i pravo Bar nudi studentima napredno obrazovanje u oblasti…",
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Poslovna ekonomija",
        path: "/poslovna-ekonomija",
      },
    ],
  },
  "/poslovna-ekonomika-m": {
    title: "Ekonomika preduzeća | Menadžment | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Ekonomika preduzeća" na programu Menadžment (Osnovne studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Menadžment",
        path: "/menadzment",
      },
      {
        name: "Ekonomika preduzeća",
        path: "/poslovna-ekonomika-m",
      },
    ],
    courseTitle: "Ekonomika preduzeća",
    programName: "Menadžment",
    studyLevel: "Osnovne studije",
  },
  "/poslovna-informatika-m": {
    title: "Poslovna informatika | Menadžment | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Poslovna informatika" na programu Menadžment (Osnovne studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Menadžment",
        path: "/menadzment",
      },
      {
        name: "Poslovna informatika",
        path: "/poslovna-informatika-m",
      },
    ],
    courseTitle: "Poslovna informatika",
    programName: "Menadžment",
    studyLevel: "Osnovne studije",
  },
  "/poslovna-informatika-rfb": {
    title:
      "Poslovna informatika | Računovodstvo, finansije i bankarstvo | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Poslovna informatika" na programu Računovodstvo, finansije i bankarstvo (Osnovne studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Računovodstvo, finansije i bankarstvo",
        path: "/racunovodstvo-finansije-i-bankarstvo",
      },
      {
        name: "Poslovna informatika",
        path: "/poslovna-informatika-rfb",
      },
    ],
    courseTitle: "Poslovna informatika",
    programName: "Računovodstvo, finansije i bankarstvo",
    studyLevel: "Osnovne studije",
  },
  "/poslovna-kultura-i-organizaciono-ponasanje-rfb": {
    title:
      "Poslovna kultura i organizaciono ponašanje | Računovodstvo, finansije i bankarstvo | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Poslovna kultura i organizaciono ponašanje" na programu Računovodstvo, finansije i bankarstvo (Osnovne studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Računovodstvo, finansije i bankarstvo",
        path: "/racunovodstvo-finansije-i-bankarstvo",
      },
      {
        name: "Poslovna kultura i organizaciono ponašanje",
        path: "/poslovna-kultura-i-organizaciono-ponasanje-rfb",
      },
    ],
    courseTitle: "Poslovna kultura i organizaciono ponašanje",
    programName: "Računovodstvo, finansije i bankarstvo",
    studyLevel: "Osnovne studije",
  },
  "/poslovna-kultura-organizaciono-ponasanje-m": {
    title: "Poslovna kultura i organizaciono ponašanje | Menadžment | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Poslovna kultura i organizaciono ponašanje" na programu Menadžment (Osnovne studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Menadžment",
        path: "/menadzment",
      },
      {
        name: "Poslovna kultura i organizaciono ponašanje",
        path: "/poslovna-kultura-organizaciono-ponasanje-m",
      },
    ],
    courseTitle: "Poslovna kultura i organizaciono ponašanje",
    programName: "Menadžment",
    studyLevel: "Osnovne studije",
  },
  "/poslovna-psihologija-m": {
    title: "Poslovna psihologija | Menadžment | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Poslovna psihologija" na programu Menadžment (Osnovne studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Menadžment",
        path: "/menadzment",
      },
      {
        name: "Poslovna psihologija",
        path: "/poslovna-psihologija-m",
      },
    ],
    courseTitle: "Poslovna psihologija",
    programName: "Menadžment",
    studyLevel: "Osnovne studije",
  },
  "/poslovne-finansije-rfb": {
    title:
      "Poslovne finansije | Računovodstvo, finansije i bankarstvo | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Poslovne finansije" na programu Računovodstvo, finansije i bankarstvo (Osnovne studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Računovodstvo, finansije i bankarstvo",
        path: "/racunovodstvo-finansije-i-bankarstvo",
      },
      {
        name: "Poslovne finansije",
        path: "/poslovne-finansije-rfb",
      },
    ],
    courseTitle: "Poslovne finansije",
    programName: "Računovodstvo, finansije i bankarstvo",
    studyLevel: "Osnovne studije",
  },
  "/poslovno-odlucivanje-m": {
    title: "Poslovno odlučivanje | Menadžment | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Poslovno odlučivanje" na programu Menadžment (Osnovne studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Menadžment",
        path: "/menadzment",
      },
      {
        name: "Poslovno odlučivanje",
        path: "/poslovno-odlucivanje-m",
      },
    ],
    courseTitle: "Poslovno odlučivanje",
    programName: "Menadžment",
    studyLevel: "Osnovne studije",
  },
  "/poslovno-odlucivanje-rfb": {
    title:
      "Poslovno odlučivanje | Računovodstvo, finansije i bankarstvo | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Poslovno odlučivanje" na programu Računovodstvo, finansije i bankarstvo (Osnovne studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Računovodstvo, finansije i bankarstvo",
        path: "/racunovodstvo-finansije-i-bankarstvo",
      },
      {
        name: "Poslovno odlučivanje",
        path: "/poslovno-odlucivanje-rfb",
      },
    ],
    courseTitle: "Poslovno odlučivanje",
    programName: "Računovodstvo, finansije i bankarstvo",
    studyLevel: "Osnovne studije",
  },
  "/pravna-etika-kultura-poas": {
    title: "Pravna etika i kultura | Pravo | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Pravna etika i kultura" na programu Pravo (Osnovne studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Pravo",
        path: "/pravo-osnovne",
      },
      {
        name: "Pravna etika i kultura",
        path: "/pravna-etika-kultura-poas",
      },
    ],
    courseTitle: "Pravna etika i kultura",
    programName: "Pravo",
    studyLevel: "Osnovne studije",
  },
  "/pravno-normiranje-pm": {
    title: "Pravno normiranje | Pravo | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Pravno normiranje" na programu Pravo (Master studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Pravo",
        path: "/pravo-master",
      },
      {
        name: "Pravno normiranje",
        path: "/pravno-normiranje-pm",
      },
    ],
    courseTitle: "Pravno normiranje",
    programName: "Pravo",
    studyLevel: "Master studije",
  },
  "/pravo-eu-poas": {
    title: "Pravo EU | Pravo | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Pravo EU" na programu Pravo (Osnovne studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Pravo",
        path: "/pravo-osnovne",
      },
      {
        name: "Pravo EU",
        path: "/pravo-eu-poas",
      },
    ],
    courseTitle: "Pravo EU",
    programName: "Pravo",
    studyLevel: "Osnovne studije",
  },
  "/pravo-intelektualne-svojine-ejs": {
    title: "Pravo intelektualne svojine | Ekonomija javnog sektora | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Pravo intelektualne svojine" na programu Ekonomija javnog sektora (Master studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Ekonomija javnog sektora",
        path: "/ekonomija-javnog-sektora",
      },
      {
        name: "Pravo intelektualne svojine",
        path: "/pravo-intelektualne-svojine-ejs",
      },
    ],
    courseTitle: "Pravo intelektualne svojine",
    programName: "Ekonomija javnog sektora",
    studyLevel: "Master studije",
  },
  "/pravo-intelektualne-svojine-pem": {
    title: "Pravo intelektualne svojine | Poslovna ekonomija | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Pravo intelektualne svojine" na programu Poslovna ekonomija (Master studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Poslovna ekonomija",
        path: "/poslovna-ekonomija",
      },
      {
        name: "Pravo intelektualne svojine",
        path: "/pravo-intelektualne-svojine-pem",
      },
    ],
    courseTitle: "Pravo intelektualne svojine",
    programName: "Poslovna ekonomija",
    studyLevel: "Master studije",
  },
  "/pravo-intelektualne-svojine-pm": {
    title: "Pravo intelektualne svojine | Pravo | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Pravo intelektualne svojine" na programu Pravo (Master studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Pravo",
        path: "/pravo-master",
      },
      {
        name: "Pravo intelektualne svojine",
        path: "/pravo-intelektualne-svojine-pm",
      },
    ],
    courseTitle: "Pravo intelektualne svojine",
    programName: "Pravo",
    studyLevel: "Master studije",
  },
  "/pravo-master": {
    title: "Pravo – master studije | FPEP Bar",
    description:
      "Program postdiplomskih akademskih studija 'Pravo' na Fakultetu za poslovnu ekonomiju i pravo Bar namijenjen je studentima koji žele da steknu napredno znanje…",
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Pravo – master studije",
        path: "/pravo-master",
      },
    ],
  },
  "/pravo-osnovne": {
    title: "Pravo – osnovne studije | FPEP Bar",
    description:
      "Program osnovnih akademskih studija 'Pravo' na Fakultetu za poslovnu ekonomiju i pravo Bar nudi sveobuhvatno obrazovanje u oblasti prava kroz teorijska i…",
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Pravo – osnovne studije",
        path: "/pravo-osnovne",
      },
    ],
  },
  "/preduzetnicki-menadzment-m": {
    title: "Preduzetnički menadžment | Menadžment | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Preduzetnički menadžment" na programu Menadžment (Osnovne studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Menadžment",
        path: "/menadzment",
      },
      {
        name: "Preduzetnički menadžment",
        path: "/preduzetnicki-menadzment-m",
      },
    ],
    courseTitle: "Preduzetnički menadžment",
    programName: "Menadžment",
    studyLevel: "Osnovne studije",
  },
  "/prekrsajno-pravo-poas": {
    title: "Prekršajno pravo | Pravo | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Prekršajno pravo" na programu Pravo (Osnovne studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Pravo",
        path: "/pravo-osnovne",
      },
      {
        name: "Prekršajno pravo",
        path: "/prekrsajno-pravo-poas",
      },
    ],
    courseTitle: "Prekršajno pravo",
    programName: "Pravo",
    studyLevel: "Osnovne studije",
  },
  "/prelazak-sa-drugih-fakulteta": {
    title: "Prelazak sa drugih fakulteta | FPEP Bar",
    description:
      "Informacije o prepisu i prelasku sa drugih fakulteta na FPEP Bar: uslovi, potrebna dokumentacija, pravila priznavanja ispita i postupak prijave.",
    pageType: "WebPage",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Upis",
        path: "/upis",
      },
      {
        name: "Prelazak sa drugih fakulteta",
        path: "/prelazak-sa-drugih-fakulteta",
      },
    ],
  },
  "/projekti": {
    title: "Projekti | FPEP Bar",
    description:
      "Pregled nacionalnih i međunarodnih projekata FPEP Bar, sa fokusom na Erasmus+, digitalnu transformaciju, inovacije i akademsku saradnju.",
    pageType: "CollectionPage",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Projekti",
        path: "/projekti",
      },
    ],
  },
  "/projekti/digicreate": {
    title: "DigiCreate projekat | FPEP Bar",
    description:
      "DigiCreate projekat na FPEP Bar: digitalne i preduzetničke kompetencije, virtuelne razmjene i međunarodna saradnja za mlade i kreativne industrije.",
    pageType: "WebPage",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Projekti",
        path: "/projekti",
      },
      {
        name: "DigiCreate",
        path: "/projekti/digicreate",
      },
    ],
  },
  "/projekti/erasmus-ka171-connecting-continents": {
    title: "Erasmus+ KA171 Connecting Continents | FPEP Bar",
    description:
      "Detalji Erasmus+ KA171 projekta Connecting Continents: međunarodne mobilnosti, partneri, ciljevi projekta i uloga FPEP Bar u akademskoj saradnji.",
    pageType: "WebPage",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Projekti",
        path: "/projekti",
      },
      {
        name: "Erasmus+ KA171",
        path: "/projekti/erasmus-ka171-connecting-continents",
      },
    ],
  },
  "/projekti/lands": {
    title: "LANDS projekat | FPEP Bar",
    description:
      "LANDS projekat FPEP Bar: međunarodna saradnja, senzori, pilot aktivnosti i podrška inovacijama i predikciji rizika kroz Interreg pristup.",
    pageType: "WebPage",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Projekti",
        path: "/projekti",
      },
      {
        name: "LANDS",
        path: "/projekti/lands",
      },
    ],
  },
  "/projekti/prodigy-e": {
    title: "Prodigy-E projekat | FPEP Bar",
    description:
      "Prodigy-E na FPEP Bar: digitalna transformacija, inovacije u visokom obrazovanju i razvoj kompetencija kroz Erasmus+ CBHE saradnju.",
    pageType: "WebPage",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Projekti",
        path: "/projekti",
      },
      {
        name: "Prodigy-E",
        path: "/projekti/prodigy-e",
      },
    ],
  },
  "/projekti/reimagine": {
    title: "RE-IMAGINE projekat | FPEP Bar",
    description:
      "RE-IMAGINE na FPEP Bar: odgovorna digitalizacija, ORRI pristup, etika u praksi i savremeni model razvoja visokog obrazovanja.",
    pageType: "WebPage",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Projekti",
        path: "/projekti",
      },
      {
        name: "RE-IMAGINE",
        path: "/projekti/reimagine",
      },
    ],
  },
  "/projekti/res-uni": {
    title: "Res-Uni projekat | FPEP Bar",
    description:
      "Res-Uni projekat na FPEP Bar: jačanje istraživačkih kapaciteta, internacionalizacija i razvoj univerzitetske saradnje u okviru Erasmus+ CBHE.",
    pageType: "WebPage",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Projekti",
        path: "/projekti",
      },
      {
        name: "Res-Uni",
        path: "/projekti/res-uni",
      },
    ],
  },
  "/racunovodstvo-finansije-i-bankarstvo": {
    title: "Računovodstvo, finansije i bankarstvo | FPEP Bar",
    description:
      "Program osnovnih akademskih studija 'Računovodstvo, finansije i bankarstvo' na Fakultetu za poslovnu ekonomiju i pravo Bar nudi sveobuhvatan pristup…",
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Računovodstvo, finansije i bankarstvo",
        path: "/racunovodstvo-finansije-i-bankarstvo",
      },
    ],
  },
  "/racunovodstvo-m": {
    title: "Računovodstvo | Menadžment | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Računovodstvo" na programu Menadžment (Osnovne studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Menadžment",
        path: "/menadzment",
      },
      {
        name: "Računovodstvo",
        path: "/racunovodstvo-m",
      },
    ],
    courseTitle: "Računovodstvo",
    programName: "Menadžment",
    studyLevel: "Osnovne studije",
  },
  "/racunovodstvo-rfb": {
    title: "Računovodstvo | Računovodstvo, finansije i bankarstvo | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Računovodstvo" na programu Računovodstvo, finansije i bankarstvo (Osnovne studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Računovodstvo, finansije i bankarstvo",
        path: "/racunovodstvo-finansije-i-bankarstvo",
      },
      {
        name: "Računovodstvo",
        path: "/racunovodstvo-rfb",
      },
    ],
    courseTitle: "Računovodstvo",
    programName: "Računovodstvo, finansije i bankarstvo",
    studyLevel: "Osnovne studije",
  },
  "/radno-pravo-poas": {
    title: "Radno pravo | Pravo | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Radno pravo" na programu Pravo (Osnovne studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Pravo",
        path: "/pravo-osnovne",
      },
      {
        name: "Radno pravo",
        path: "/radno-pravo-poas",
      },
    ],
    courseTitle: "Radno pravo",
    programName: "Pravo",
    studyLevel: "Osnovne studije",
  },
  "/rijec-dekana": {
    title: "Riječ dekana | FPEP Bar",
    description:
      "Poruka dekana Fakulteta za poslovnu ekonomiju i pravo Bar o studijama, razvoju studenata, kvalitetu nastave i akademskim vrijednostima ustanove.",
    pageType: "AboutPage",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "O nama",
        path: "/o-nama",
      },
      {
        name: "Riječ dekana",
        path: "/rijec-dekana",
      },
    ],
  },
  "/rimsko-pravo-poas": {
    title: "Rimsko pravo | Pravo | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Rimsko pravo" na programu Pravo (Osnovne studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Pravo",
        path: "/pravo-osnovne",
      },
      {
        name: "Rimsko pravo",
        path: "/rimsko-pravo-poas",
      },
    ],
    courseTitle: "Rimsko pravo",
    programName: "Pravo",
    studyLevel: "Osnovne studije",
  },
  "/sigurnost-zastita-IS-m": {
    title: "Sigurnost i zaštita informacionih sistema | Menadžment | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Sigurnost i zaštita informacionih sistema" na programu Menadžment (Osnovne studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Menadžment",
        path: "/menadzment",
      },
      {
        name: "Sigurnost i zaštita informacionih sistema",
        path: "/sigurnost-zastita-IS-m",
      },
    ],
    courseTitle: "Sigurnost i zaštita informacionih sistema",
    programName: "Menadžment",
    studyLevel: "Osnovne studije",
  },
  "/sociologija-m": {
    title: "Sociologija | Menadžment | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Sociologija" na programu Menadžment (Osnovne studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Menadžment",
        path: "/menadzment",
      },
      {
        name: "Sociologija",
        path: "/sociologija-m",
      },
    ],
    courseTitle: "Sociologija",
    programName: "Menadžment",
    studyLevel: "Osnovne studije",
  },
  "/sociologija-poas": {
    title: "Sociologija | Pravo | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Sociologija" na programu Pravo (Osnovne studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Pravo",
        path: "/pravo-osnovne",
      },
      {
        name: "Sociologija",
        path: "/sociologija-poas",
      },
    ],
    courseTitle: "Sociologija",
    programName: "Pravo",
    studyLevel: "Osnovne studije",
  },
  "/sociologija-rfb": {
    title: "Sociologija | Računovodstvo, finansije i bankarstvo | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Sociologija" na programu Računovodstvo, finansije i bankarstvo (Osnovne studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Računovodstvo, finansije i bankarstvo",
        path: "/racunovodstvo-finansije-i-bankarstvo",
      },
      {
        name: "Sociologija",
        path: "/sociologija-rfb",
      },
    ],
    courseTitle: "Sociologija",
    programName: "Računovodstvo, finansije i bankarstvo",
    studyLevel: "Osnovne studije",
  },
  "/stecajno-pravo-poas": {
    title: "Stečajno pravo | Pravo | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Stečajno pravo" na programu Pravo (Osnovne studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Pravo",
        path: "/pravo-osnovne",
      },
      {
        name: "Stečajno pravo",
        path: "/stecajno-pravo-poas",
      },
    ],
    courseTitle: "Stečajno pravo",
    programName: "Pravo",
    studyLevel: "Osnovne studije",
  },
  "/strategija-razvoja-fpep-2026-2029": {
    title: "Strategija razvoja 2026–2029 | FPEP Bar",
    description:
      "Strategija razvoja FPEP Bar 2026–2029: prioriteti, ciljevi, institucionalni razvoj, kvalitet, internacionalizacija i unapređenje nastavnog procesa.",
    pageType: "WebPage",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "O nama",
        path: "/o-nama",
      },
      {
        name: "Strategija razvoja 2026–2029",
        path: "/strategija-razvoja-fpep-2026-2029",
      },
    ],
  },
  "/strategijski-menadzment-m": {
    title: "Strategijski menadžment | Menadžment | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Strategijski menadžment" na programu Menadžment (Osnovne studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Menadžment",
        path: "/menadzment",
      },
      {
        name: "Strategijski menadžment",
        path: "/strategijski-menadzment-m",
      },
    ],
    courseTitle: "Strategijski menadžment",
    programName: "Menadžment",
    studyLevel: "Osnovne studije",
  },
  "/strateski-menadzment-javnog-sektora-ejs": {
    title:
      "Strateški menadžment javnog sektora | Ekonomija javnog sektora | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Strateški menadžment javnog sektora" na programu Ekonomija javnog sektora (Master studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Ekonomija javnog sektora",
        path: "/ekonomija-javnog-sektora",
      },
      {
        name: "Strateški menadžment javnog sektora",
        path: "/strateski-menadzment-javnog-sektora-ejs",
      },
    ],
    courseTitle: "Strateški menadžment javnog sektora",
    programName: "Ekonomija javnog sektora",
    studyLevel: "Master studije",
  },
  "/studenti": {
    title: "Studenti | FPEP Bar",
    description:
      "Studentske informacije na FPEP Bar: studentski parlament, dom studenata, alumni klub, servisne informacije i sadržaji važni za studentski život.",
    pageType: "CollectionPage",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studenti",
        path: "/studenti",
      },
    ],
  },
  "/studentski-parlament": {
    title: "Studentski parlament | FPEP Bar",
    description:
      "Studentski parlament FPEP Bar — predstavljanje studentskog organizovanja, aktivnosti, inicijative i zastupanje interesa studenata.",
    pageType: "WebPage",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studenti",
        path: "/studenti",
      },
      {
        name: "Studentski parlament",
        path: "/studentski-parlament",
      },
    ],
  },
  "/svi-studijski-programi": {
    title: "Studijski programi | FPEP Bar",
    description:
      "Pregled svih studijskih programa Fakulteta za poslovnu ekonomiju i pravo Bar: ekonomija, menadžment, pravo, specijalističke i master studije.",
    pageType: "CollectionPage",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
    ],
  },
  "/transport-spedicija-i-poslovanje-rfb": {
    title:
      "Transport špedicija i osiguranje | Računovodstvo, finansije i bankarstvo | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Transport špedicija i osiguranje" na programu Računovodstvo, finansije i bankarstvo (Osnovne studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Računovodstvo, finansije i bankarstvo",
        path: "/racunovodstvo-finansije-i-bankarstvo",
      },
      {
        name: "Transport špedicija i osiguranje",
        path: "/transport-spedicija-i-poslovanje-rfb",
      },
    ],
    courseTitle: "Transport špedicija i osiguranje",
    programName: "Računovodstvo, finansije i bankarstvo",
    studyLevel: "Osnovne studije",
  },
  "/ugovorno-pravo-pm": {
    title: "Ugovorno pravo | Pravo | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Ugovorno pravo" na programu Pravo (Master studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Pravo",
        path: "/pravo-master",
      },
      {
        name: "Ugovorno pravo",
        path: "/ugovorno-pravo-pm",
      },
    ],
    courseTitle: "Ugovorno pravo",
    programName: "Pravo",
    studyLevel: "Master studije",
  },
  "/upis": {
    title: "Upis | FPEP Bar",
    description:
      "Informacije o upisu na FPEP Bar: uslovi, potrebna dokumentacija, postupak prijave, rokovi, školarina i važne smjernice za buduće studente.",
    pageType: "WebPage",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Upis",
        path: "/upis",
      },
    ],
  },
  "/upisni-rokovi": {
    title: "Upisni rokovi | FPEP Bar",
    description:
      "Aktuelni upisni rokovi na FPEP Bar, termini prijava, uslovi konkurisanja i važne informacije za upis na studijske programe.",
    pageType: "WebPage",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Upis",
        path: "/upis",
      },
      {
        name: "Upisni rokovi",
        path: "/upisni-rokovi",
      },
    ],
  },
  "/upravljacko-racunovodstvo-m": {
    title: "Upravljačko računovodstvo | Menadžment | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Upravljačko računovodstvo" na programu Menadžment (Osnovne studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Menadžment",
        path: "/menadzment",
      },
      {
        name: "Upravljačko računovodstvo",
        path: "/upravljacko-racunovodstvo-m",
      },
    ],
    courseTitle: "Upravljačko računovodstvo",
    programName: "Menadžment",
    studyLevel: "Osnovne studije",
  },
  "/upravljacko-racunovodstvo-rfb": {
    title:
      "Upravljačko računovodstvo | Računovodstvo, finansije i bankarstvo | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Upravljačko računovodstvo" na programu Računovodstvo, finansije i bankarstvo (Osnovne studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Računovodstvo, finansije i bankarstvo",
        path: "/racunovodstvo-finansije-i-bankarstvo",
      },
      {
        name: "Upravljačko računovodstvo",
        path: "/upravljacko-racunovodstvo-rfb",
      },
    ],
    courseTitle: "Upravljačko računovodstvo",
    programName: "Računovodstvo, finansije i bankarstvo",
    studyLevel: "Osnovne studije",
  },
  "/upravljanje-investicijama-pem": {
    title: "Upravljanje investicijama | Poslovna ekonomija | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Upravljanje investicijama" na programu Poslovna ekonomija (Master studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Poslovna ekonomija",
        path: "/poslovna-ekonomija",
      },
      {
        name: "Upravljanje investicijama",
        path: "/upravljanje-investicijama-pem",
      },
    ],
    courseTitle: "Upravljanje investicijama",
    programName: "Poslovna ekonomija",
    studyLevel: "Master studije",
  },
  "/upravljanje-is-ejs": {
    title:
      "Upravljanje informacionim sistemima | Ekonomija javnog sektora | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Upravljanje informacionim sistemima" na programu Ekonomija javnog sektora (Master studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Ekonomija javnog sektora",
        path: "/ekonomija-javnog-sektora",
      },
      {
        name: "Upravljanje informacionim sistemima",
        path: "/upravljanje-is-ejs",
      },
    ],
    courseTitle: "Upravljanje informacionim sistemima",
    programName: "Ekonomija javnog sektora",
    studyLevel: "Master studije",
  },
  "/upravljanje-is-pem": {
    title:
      "Upravljanje informacionim sistemima | Poslovna ekonomija | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Upravljanje informacionim sistemima" na programu Poslovna ekonomija (Master studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Poslovna ekonomija",
        path: "/poslovna-ekonomija",
      },
      {
        name: "Upravljanje informacionim sistemima",
        path: "/upravljanje-is-pem",
      },
    ],
    courseTitle: "Upravljanje informacionim sistemima",
    programName: "Poslovna ekonomija",
    studyLevel: "Master studije",
  },
  "/upravljanje-kvalitetom-m": {
    title: "Upravljanje kvalitetom | Menadžment | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Upravljanje kvalitetom" na programu Menadžment (Osnovne studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Menadžment",
        path: "/menadzment",
      },
      {
        name: "Upravljanje kvalitetom",
        path: "/upravljanje-kvalitetom-m",
      },
    ],
    courseTitle: "Upravljanje kvalitetom",
    programName: "Menadžment",
    studyLevel: "Osnovne studije",
  },
  "/upravljanje-kvalitetom-rfb": {
    title:
      "Upravljanje kvalitetom | Računovodstvo, finansije i bankarstvo | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Upravljanje kvalitetom" na programu Računovodstvo, finansije i bankarstvo (Osnovne studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Računovodstvo, finansije i bankarstvo",
        path: "/racunovodstvo-finansije-i-bankarstvo",
      },
      {
        name: "Upravljanje kvalitetom",
        path: "/upravljanje-kvalitetom-rfb",
      },
    ],
    courseTitle: "Upravljanje kvalitetom",
    programName: "Računovodstvo, finansije i bankarstvo",
    studyLevel: "Osnovne studije",
  },
  "/upravljanje-odnosima-sa-javnoscu-ejs": {
    title:
      "Upravljanje odnosima s javnošću | Ekonomija javnog sektora | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Upravljanje odnosima s javnošću" na programu Ekonomija javnog sektora (Master studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Ekonomija javnog sektora",
        path: "/ekonomija-javnog-sektora",
      },
      {
        name: "Upravljanje odnosima s javnošću",
        path: "/upravljanje-odnosima-sa-javnoscu-ejs",
      },
    ],
    courseTitle: "Upravljanje odnosima s javnošću",
    programName: "Ekonomija javnog sektora",
    studyLevel: "Master studije",
  },
  "/upravljanje-odnosima-sa-javnoscu-pem": {
    title: "Upravljanje odnosima s javnošću | Poslovna ekonomija | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Upravljanje odnosima s javnošću" na programu Poslovna ekonomija (Master studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Poslovna ekonomija",
        path: "/poslovna-ekonomija",
      },
      {
        name: "Upravljanje odnosima s javnošću",
        path: "/upravljanje-odnosima-sa-javnoscu-pem",
      },
    ],
    courseTitle: "Upravljanje odnosima s javnošću",
    programName: "Poslovna ekonomija",
    studyLevel: "Master studije",
  },
  "/upravljanje-troskovima-u-poslovnom-odlucivanju-pem": {
    title:
      "Upravljanje troškovima u poslovnom odlučivanju | Poslovna ekonomija | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Upravljanje troškovima u poslovnom odlučivanju" na programu Poslovna ekonomija (Master studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Poslovna ekonomija",
        path: "/poslovna-ekonomija",
      },
      {
        name: "Upravljanje troškovima u poslovnom odlučivanju",
        path: "/upravljanje-troskovima-u-poslovnom-odlucivanju-pem",
      },
    ],
    courseTitle: "Upravljanje troškovima u poslovnom odlučivanju",
    programName: "Poslovna ekonomija",
    studyLevel: "Master studije",
  },
  "/upravno-pravo-poas": {
    title: "Upravno pravo | Pravo | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Upravno pravo" na programu Pravo (Osnovne studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Pravo",
        path: "/pravo-osnovne",
      },
      {
        name: "Upravno pravo",
        path: "/upravno-pravo-poas",
      },
    ],
    courseTitle: "Upravno pravo",
    programName: "Pravo",
    studyLevel: "Osnovne studije",
  },
  "/ustavno-pravo-poas": {
    title: "Ustavno pravo | Pravo | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Ustavno pravo" na programu Pravo (Osnovne studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Pravo",
        path: "/pravo-osnovne",
      },
      {
        name: "Ustavno pravo",
        path: "/ustavno-pravo-poas",
      },
    ],
    courseTitle: "Ustavno pravo",
    programName: "Pravo",
    studyLevel: "Osnovne studije",
  },
  "/uvod-u-pravo-evropskih-integracija-poas": {
    title: "Uvod u pravo Evropskih integracija | Pravo | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Uvod u pravo Evropskih integracija" na programu Pravo (Osnovne studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Pravo",
        path: "/pravo-osnovne",
      },
      {
        name: "Uvod u pravo Evropskih integracija",
        path: "/uvod-u-pravo-evropskih-integracija-poas",
      },
    ],
    courseTitle: "Uvod u pravo Evropskih integracija",
    programName: "Pravo",
    studyLevel: "Osnovne studije",
  },
  "/uvod-u-pravo-poas": {
    title: "Uvod u pravo | Pravo | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Uvod u pravo" na programu Pravo (Osnovne studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Pravo",
        path: "/pravo-osnovne",
      },
      {
        name: "Uvod u pravo",
        path: "/uvod-u-pravo-poas",
      },
    ],
    courseTitle: "Uvod u pravo",
    programName: "Pravo",
    studyLevel: "Osnovne studije",
  },
  "/vanparnicni-i-izvrsni-postupak-pm": {
    title: "Vanparnični i izvršni postupak | Pravo | FPEP Bar",
    description:
      'Detaljan pregled predmeta "Vanparnični i izvršni postupak" na programu Pravo (Master studije) na Fakultetu za poslovnu ekonomiju i pravo Bar.',
    pageType: "Course",
    breadcrumbs: [
      {
        name: "Početna",
        path: "/",
      },
      {
        name: "Studijski programi",
        path: "/svi-studijski-programi",
      },
      {
        name: "Pravo",
        path: "/pravo-master",
      },
      {
        name: "Vanparnični i izvršni postupak",
        path: "/vanparnicni-i-izvrsni-postupak-pm",
      },
    ],
    courseTitle: "Vanparnični i izvršni postupak",
    programName: "Pravo",
    studyLevel: "Master studije",
  },
};

const CORE_ROUTE_SEO_EN = {
  "/": {
    title: "FPEP Bar | Faculty of Business Economics and Law",
    description:
      "Faculty of Business Economics and Law Bar — study programmes in economics, management and law, admissions, Erasmus+, international projects and student life.",
    breadcrumbs: [{ name: "Home", path: "/" }],
  },
  "/aktuelnosti/ljetnja-skola-bar-2026": {
    title: "Summer School Bar 2026 | FPEP Bar",
    description:
      "Summer School Bar 2026 at FPEP Bar: an international programme with students from the University of Applied Sciences Burgenland, institutional visits, classes, culture and discovery of Montenegro.",
    breadcrumbs: [
      { name: "Home", path: "/" },
      { name: "Updates", path: "/novosti" },
      {
        name: "Summer School Bar 2026",
        path: "/aktuelnosti/ljetnja-skola-bar-2026",
      },
    ],
  },
  "/novosti": {
    title: "News | FPEP Bar",
    description:
      "Latest FPEP Bar news: announcements, student activities, international projects, events and updates for future and current students.",
    breadcrumbs: [
      { name: "Home", path: "/" },
      { name: "News", path: "/novosti" },
    ],
  },
  "/novosti/:id": {
    title: "News post | FPEP Bar",
    description:
      "Read the latest announcement, update or news post from the Faculty of Business Economics and Law Bar.",
    breadcrumbs: [
      { name: "Home", path: "/" },
      { name: "News", path: "/novosti" },
    ],
  },
  "/galerija": {
    title: "Gallery | FPEP Bar",
    description:
      "Photo gallery of the Faculty of Business Economics and Law Bar — events, student activities, academic life and institutional moments.",
    breadcrumbs: [
      { name: "Home", path: "/" },
      { name: "Gallery", path: "/galerija" },
    ],
  },
  "/medjunarodna-saradnja": {
    title: "International Cooperation | FPEP Bar",
    description:
      "International cooperation at FPEP Bar: Erasmus+, partner institutions, mobility opportunities and international projects.",
    breadcrumbs: [
      { name: "Home", path: "/" },
      { name: "International Cooperation", path: "/medjunarodna-saradnja" },
    ],
  },
  "/erasmus": {
    title: "Erasmus+ | FPEP Bar",
    description:
      "Erasmus+ at FPEP Bar: student and staff mobilities, partner institutions, charter, international opportunities and practical information.",
    breadcrumbs: [
      { name: "Home", path: "/" },
      { name: "International Cooperation", path: "/medjunarodna-saradnja" },
      { name: "Erasmus+", path: "/erasmus" },
    ],
  },
  "/erasmus-konkursi": {
    title: "Erasmus Calls | FPEP Bar",
    description:
      "Current Erasmus calls at FPEP Bar: student, teaching and staff mobilities, application requirements and supporting documents.",
    breadcrumbs: [
      { name: "Home", path: "/" },
      { name: "International Cooperation", path: "/medjunarodna-saradnja" },
      { name: "Erasmus Calls", path: "/erasmus-konkursi" },
    ],
  },
};

function normalizeRoutePath(pathname) {
  if (!pathname) return "/";

  const cleanPath = String(pathname).split("?")[0].split("#")[0];
  return cleanPath !== "/" && cleanPath.endsWith("/")
    ? cleanPath.slice(0, -1)
    : cleanPath;
}

function getRouteSeoKey(pathname) {
  const normalized = normalizeRoutePath(pathname);

  if (ROUTE_SEO[normalized]) {
    return normalized;
  }

  if (normalized.startsWith("/novosti/")) {
    return "/novosti/:id";
  }

  return "/";
}

function isEnglishLanguage(language = "me") {
  return String(language || "me").toLowerCase().startsWith("en");
}

function localizeRouteSeo(key, meta, language) {
  if (!isEnglishLanguage(language)) return meta;

  const translation = CORE_ROUTE_SEO_EN[key];
  if (!translation) return meta;

  return {
    ...meta,
    ...translation,
    breadcrumbs: translation.breadcrumbs || meta.breadcrumbs,
  };
}

function getStaticRouteMetadata(key, language) {
  const locale = isEnglishLanguage(language) ? "en" : "me";
  return STATIC_ROUTE_METADATA?.routes?.[key]?.[locale] || null;
}

function resolveReactPageType(key, routeMeta, staticMeta) {
  if (staticMeta?.pageType === "article") return "Article";
  if (key === "/") return "WebSite";
  return routeMeta?.pageType || "WebPage";
}

export function getRouteSeo(pathname, language = "me") {
  const key = getRouteSeoKey(pathname);
  const baseMeta = ROUTE_SEO[key] || ROUTE_SEO["/"];
  const localizedMeta = localizeRouteSeo(key, baseMeta, language);
  const staticMeta = getStaticRouteMetadata(key, language);

  if (!staticMeta) return localizedMeta;

  return {
    ...localizedMeta,
    title: staticMeta.title || localizedMeta.title,
    description: staticMeta.description || localizedMeta.description,
    pageType: resolveReactPageType(key, localizedMeta, staticMeta),
    section: staticMeta.section || localizedMeta.section,
    image: staticMeta.image?.url || localizedMeta.image,
    imageAlt: staticMeta.image?.alt || staticMeta.title || localizedMeta.title,
    imageType: staticMeta.image?.mimeType || undefined,
    imageWidth: staticMeta.image?.width || undefined,
    imageHeight: staticMeta.image?.height || undefined,
    contentLanguage: staticMeta.locale?.contentLanguage || undefined,
    openGraphLocale: staticMeta.locale?.openGraph || undefined,
    alternateOpenGraphLocale: staticMeta.locale?.alternateOpenGraph || undefined,
  };
}

export default ROUTE_SEO;
